import React, { useState } from "react";
import { BasicTextInput } from "../FormComponent/BasicTextInput";
import BasicSelectInput from "../FormComponent/BasicSelectInput";
import InputFieldWithRightIndicator from "../FormComponent/InputFieldWithRightIndicator";

const Step2 = ({ data, formData1, setFormData1 }) => {
  const handleChangeFormData1 = (e) => {
    const { name, value } = e.target;
    setFormData1({
      ...formData1,
      [name]: value,
    });
  };

  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
        Information About Your Watch
      </h1>
      <p className="text-[14px] mt-4 mb-8 p-4 rounded-lg bg-primary">
        We've already filled in some details based on the model. Please check
        and correct these if necessary.
      </p>

      <BasicTextInput
        label={"Year of production (required)"}
        isRequired={true}
        type={"text"}
        id={"production"}
        name={"production"}
        value={formData1?.production}
        onChange={handleChangeFormData1}
        placeholder={"e.g., 2013"}
      />
      <BasicSelectInput
        label={"Gender"}
        name={"gender"}
        onChange={handleChangeFormData1}
        value={formData1?.gender}
        options={["Male", "Female", "Unisex"]}
        // defaultDisabledValue={"Man's watch/Unisex"}
      />
      <BasicTextInput
        label={"Serial number (will not be published)"}
        isRequired={true}
        type={"text"}
        id={"serial"}
        name={"serial"}
        value={formData1?.serial}
        onChange={handleChangeFormData1}
        placeholder={"Enter serial number.."}
      />
      <BasicTextInput
        label={"Dial color"}
        isRequired={true}
        type={"text"}
        id={"dialColor"}
        name={"dialColor"}
        value={formData1?.dialColor}
        onChange={handleChangeFormData1}
        placeholder={"Enter Dial Color"}
      />
      {/* <BasicSelectInput
        label={"Dial color"}
        name={"dialColor"}
        onChange={handleChangeFormData1}
        value={formData1?.dialColor}
        options={["Balck", "Blue", "Gray"]}
        // defaultDisabledValue={"Black"}
      /> */}

      <div>
        <label className="text-gray-700 font-medium text-sm">
          Case diameter
        </label>
        <div className="flex gap-2 items-center justify-between mt-1 mb-4 w-full">
          <InputFieldWithRightIndicator
            value={formData1?.caseDiameterX}
            onChange={handleChangeFormData1}
            id="caseDiameterX"
            name="caseDiameterX"
          />
          <p>x</p>
          <InputFieldWithRightIndicator
            value={formData1?.caseDiameterY}
            onChange={handleChangeFormData1}
            id="caseDiameterY"
            name="caseDiameterY"
          />
        </div>
      </div>

      <BasicSelectInput
        label={"Movement"}
        name={"movement"}
        onChange={handleChangeFormData1}
        value={formData1?.movement}
        options={["Automatic", "Quartz"]}
        // defaultDisabledValue={"Automatic"}
      />
      <BasicSelectInput
        label={"Case material"}
        name={"caseMaterial"}
        onChange={handleChangeFormData1}
        value={formData1?.caseMaterial}
        options={[
          "Steel",
          "Yellow Gold",
          "White Gold",
          "Rose Gold",
          "Platinum",
        ]}
        // defaultDisabledValue={"Steel"}
      />
      <BasicSelectInput
        label={"Bracelet material"}
        name={"braceletMaterial"}
        onChange={handleChangeFormData1}
        value={formData1?.braceletMaterial}
        options={[
          "Steel",
          "Half Yellow Gold",
          "Half White Gold",
          "Half Rose Gold",
          "Yellow Gold",
          "White Gold",
          "Rose Gold",
          "Platinum",
          "Leather",
          "Rubber",
        ]}
        // defaultDisabledValue={"Steel"}
      />
      <BasicTextInput
        label={"Bracelet color"}
        type={"text"}
        id={"braceletColor"}
        name={"braceletColor"}
        value={formData1?.braceletColor}
        onChange={handleChangeFormData1}
        placeholder={"Enter Bracelet Color"}
      />
    </section>
  );
};

export default Step2;
